import { render, staticRenderFns } from "./CustomerChipsAutocomplete.vue?vue&type=template&id=e5019ecc&scoped=true&"
import script from "./CustomerChipsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CustomerChipsAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./CustomerChipsAutocomplete.vue?vue&type=style&index=0&id=e5019ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5019ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5019ecc')) {
      api.createRecord('e5019ecc', component.options)
    } else {
      api.reload('e5019ecc', component.options)
    }
    module.hot.accept("./CustomerChipsAutocomplete.vue?vue&type=template&id=e5019ecc&scoped=true&", function () {
      api.rerender('e5019ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Autocomplete/CustomerChipsAutocomplete.vue"
export default component.exports